module.exports = __webpack_public_path__ + "static/media/waveform-path.2ef905d6.svg";